module.exports = __webpack_public_path__ + "img/error-400.848d1938.svg";